<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    item-text="user.nome"
    label="Usuário"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    v-bind="$attrs"
  />
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import UserGrupoService from '@/api/user-grupo-service';

const DEFAULT_LIMIT = 30;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: Object,
    grupoId: [String, Number],
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      if (!val || (this.localValue && this.localValue.user.nome === val)) return;
      this.debounceSearch(val);
    },
  },
  methods: {
    searchItems(val) {
      const searchValue = val || '';

      this.loading = true;
      UserGrupoService.getUsers(this.grupoId, {
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: `user.nome like "%${searchValue.toLowerCase()}%"`,
      })
        .then((response) => {
          this.items = this.value ? [this.value, ...response.data.content] : response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchItems, 1000);
    if (this.value) {
      this.items = [this.value, ...this.items];
    }
  },
};
</script>
